import { render } from "./CarmineList.vue?vue&type=template&id=5b25cc2e&scoped=true"
import script from "./CarmineList.vue?vue&type=script&lang=js"
export * from "./CarmineList.vue?vue&type=script&lang=js"

import "./CarmineList.vue?vue&type=style&index=0&id=5b25cc2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b25cc2e"]])

export default __exports__